import { Button, Stack, Typography } from '@mui/material';
import { DynamicIcon } from 'src/components';
import { EmptyStateCard, EmptyStateIconBubble } from './styled';

interface ApiKeysEmptyStateProps {
  onCreate: () => void;
}

export const ApiKeysEmptyState = ({ onCreate }: ApiKeysEmptyStateProps) => {
  return (
    <EmptyStateCard>
      <EmptyStateIconBubble>
        <DynamicIcon name="key" />
      </EmptyStateIconBubble>
      <Stack gap={0.5} alignItems="center">
        <Typography variant="subtitle1" fontWeight={600}>
          No API keys yet
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
          Create a key to let external tools read or write your ProVision data. Each key can be
          scoped to specific resources.
        </Typography>
      </Stack>
      <Button variant="contained" onClick={onCreate}>
        Create your first key
      </Button>
    </EmptyStateCard>
  );
};
